import classNames from 'classnames'
import React from 'react'
import styles from './LoadingIndicator.module.scss'
import type { LoadingIndicatorProps } from './types'
import { LoadingIndicatorSize, LoadingIndicatorVariant } from './types'

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  className,
  size = LoadingIndicatorSize.large,
  variant = LoadingIndicatorVariant.positive,
}) => {
  const ariaLabelAttribute = ariaLabelledBy
    ? { 'aria-labelledby': ariaLabelledBy }
    : { 'aria-label': ariaLabel }
  return (
    <div
      className={classNames(styles['pintxo-loader-container'], className)}
      data-variant={variant}
      data-size={size}
      role="status"
      aria-live="polite"
      aria-busy="true"
      {...ariaLabelAttribute}
    >
      <span className={styles['pintxo-loader-container__loader']} aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
          <path
            className={styles['pintxo-loader-container__loader__track']}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5.49963C15.5898 5.49963 18.5 8.4098 18.5 11.9998C18.5 15.5898 15.5898 18.5 12 18.5C8.41021 18.5 5.5 15.5898 5.5 11.9998C5.5 8.4098 8.41021 5.49963 12 5.49963ZM12 1.99963C17.5228 1.99963 22 6.47687 22 11.9998C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 11.9998C2 6.47687 6.47715 1.99963 12 1.99963Z"
            fillOpacity="0.21"
          />
          <path
            className={styles['pintxo-loader-container__loader__progress']}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.25 3.74963C10.25 2.78314 11.0335 1.99963 12 1.99963C13.7553 1.99963 15.4798 2.4617 17 3.3394C18.5202 4.2171 19.7825 5.4795 20.6602 6.99972C21.5379 8.51994 22 10.2444 22 11.9998C22 13.7552 21.5379 15.4797 20.6602 16.9999C19.7825 18.5201 18.5202 19.7825 17 20.6602C15.4798 21.5379 13.7553 22 12 22C10.2446 22 8.52017 21.5379 6.99998 20.6602C5.47978 19.7825 4.2174 18.5201 3.33972 16.9999C2.85648 16.1629 3.14327 15.0926 3.98028 14.6094C4.8173 14.1261 5.88758 14.4129 6.37082 15.2499C6.94133 16.2381 7.76188 17.0587 8.75 17.6292C9.73812 18.1997 10.859 18.5 12 18.5C13.141 18.5 14.2618 18.1997 15.25 17.6292C16.2381 17.0587 17.0586 16.2381 17.6291 15.2499C18.1996 14.2618 18.5 13.1408 18.5 11.9998C18.5 10.8588 18.1996 9.73786 17.6291 8.7497C17.0586 7.76155 16.2381 6.94098 15.25 6.37048C14.2618 5.79998 13.141 5.49963 12 5.49963C11.0335 5.49963 10.25 4.71613 10.25 3.74963Z"
          />
        </svg>
      </span>
    </div>
  )
}

export default LoadingIndicator
